export const debounce = (func, wait = 20) => {
  let timeout;
  const wrapper = (...args) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      clearTimeout(timeout);
      func(...args);
    }, wait);
  };
  return wrapper;
};
export const debouncePromise = (func, wait = 200) => {
  let timeout;
  let currentReject;
  const wrapper = (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    if (currentReject) {
      currentReject();
    }

    const aPromise = new Promise((resolve, reject) => {
      currentReject = reject;
      timeout = setTimeout(async () => {
        clearTimeout(timeout);
        const res = await func(...args);
        resolve(res);
      }, wait);
    });
    return aPromise;
  };
  return wrapper;
};
export default debounce;
